import React, { FC } from 'react'
import { PricingType } from '../../../redux/pricing/types'
import { StyledCartPrice } from '.'

type Props = {
  item: PricingType;
}

const CartPrice: FC<Props> = ({ item }) => {
  const getTotal = () => {
    if (item.sale) {
      return item.sale.valueAfterDiscount.toFixed(2)
    }

    return item.price.toFixed(2)
  }

  return (
    <StyledCartPrice className="pricing-details">
      <span className="pricing-total">${getTotal()}</span>
      {item.sale && <span className="pricing-discount">${item.price.toFixed(2)}</span>}
    </StyledCartPrice>
  )
}

export default CartPrice
